<!--  -->
<template>
  <page pageDataUrl="/api/pageData/easy/search"
        v-on:paddingData="paddingPageData"
        :params="this.$route.query"
        :hasbreadcrumbs="true"
        defPageTitle='轻包装相关搜索结果'
        ref="page">

    <div class='content'>
      <h1 class="entry-title">轻包装相关搜索结果</h1>
      <div class="commonPad jyoukenWrap">
        <h2 class="itemTit">■搜索条件</h2>
        <ul class="keiSearchUl">
          <li><span class="keiSearchB">密封方法：</span>{{search_data}}</li>
          <li><span class="keiSearchB">内容：</span>{{query.p2}}</li>
        </ul>
      </div>
      <easySearch>
      </easySearch>

      <div v-if="results !== undefined &&  results.length>0">
        <div class="light-packaging-item"
             v-for="(item, index) in currentList"
             :key="index">
          <!-- <router-link :to="{path:/}"> -->
          <router-link :to="{path:'/units/easy/'+item.pLink}">
            <h1 class="light-packaging-item-title">{{item.pName}}</h1>
          </router-link>
          <div class="light-packaging-item-content">
            <div class="light-packaging-item-content-l">
              <a :href="item.pPic"><img :src="item.pPic"></a>
            </div>

            <div class="light-packaging-item-content-r">
              <div>
                <p style="font-weight: bold;color: #314478;width: 65px;">■用途：</p>
                <p>{{item.pUse}}</p>
              </div>

              <!-- <div>
                                <p style="font-weight: bold;color: #314478;">■密封方法：</p>
                                <p>{{item.pFenkou}}</p>
                            </div> -->
            </div>
          </div>
        </div>
        <div style="margin-top:50px;    text-align: center;">
          <el-pagination layout="prev, pager, next"
                         :total="results.length"
                         @current-change="currentChange">
          </el-pagination>
        </div>
      </div>

      <div v-if="results === undefined || results.length <= 0"
           class="no-data">
        什么也没找到，请用别的密封方法或用途内容试一试。
      </div>
    </div>
  </page>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      results: [],
      currentList: [],
      query: {},
      search_data: "",
      pFenkous: [
        {
          value: "",
          label: "无"
        },
        {
          value: "1",
          label: "Cielo无尽"
        },
        {
          value: "2",
          label: "密封带"
        },
        {
          value: "3",
          label: "贴纸脚踩"
        },
        {
          value: "4",
          label: "装订 - 胶带"
        },
        {
          value: "5",
          label: "装订 -  Binitai"
        },
        {
          value: "6",
          label: "装订 -  抽绳"
        },
        {
          value: "7",
          label: "装订 -  扇形"
        }
      ]
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    currentChange(val) {
      var start = (val - 1) * 10;
      var end = val * 10;
      if (end > this.results.length) end = this.results.length;
      this.currentList = this.results.slice(start, end);
    },
    // reload() {
    //     this.title = "【" + this.search_str + "】的搜索结果"
    //     this.$refs.page.reload({ s: this.search_str }, this.title)
    // },
    paddingPageData(data) {
      this.results = data.data;
      this.currentChange(1);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.query = this.$route.query;
    for (var i = 0, len = this.pFenkous.length; i < len; i++) {
      if (this.query.p1 === this.pFenkous[i].value) {
        this.search_data = this.pFenkous[i].label;
        break;
      }
    }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
.jyoukenWrap {
  margin-bottom: 30px;
}

.commonPad {
  padding: 0 15px;
}

.commonPad h2.itemTit,
h2.sampleTit {
  color: #314478;
  font-size: 100%;
  text-align: left;
  padding-left: 0.65em;
  text-indent: -0.65em;
  line-height: 1.4;
  letter-spacing: normal;
  margin-bottom: 10px;
}

.keiSearchUl {
  border-radius: 4px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
  padding: 8px 19px;
  margin: 2em 0;
  color: #2c2c2f;
  background: #fff9df;
  border-top: solid 5px #f68100;
  border-bottom: solid 5px #f68100;
}

.keiSearchUl li {
  text-align: left;
  line-height: normal;
}

.keiSearchB {
  font-weight: bold;
}
</style>